module.exports = __webpack_public_path__ + "img/giulio.c87ed3cd.png";